import React, { useState } from "react";

import { Tab, Typography } from "clearsense-ui/components";

import Associations from "./Associations";
import Edit from "./Edit";
import StatusDetails from "./StatusDetails";

const PrimaryTabs = ({
  data,
  npiRecords,
  searchParams,
  isViewMode,
  userPermissions,
  currentEntityID,
  currentEntityItemID,
  entities,
  currentNPIRecord,
  updateData,
  handleSearch,
}) => {
  const [activeTab, setActiveTab] = useState("edit");

  return (
    <div>
      <Typography style="h4" type="semibold">
        Entity Item Details
      </Typography>
      <Tab style="secondary">
        <Tab.Item
          active={activeTab === "edit"}
          onClick={() => setActiveTab("edit")}
        >
          Details
        </Tab.Item>
        <Tab.Item
          active={activeTab === "associations"}
          onClick={() => setActiveTab("associations")}
        >
          Associations
        </Tab.Item>
        <Tab.Item
          active={activeTab === "status"}
          onClick={() => setActiveTab("status")}
        >
          Status Details
        </Tab.Item>
      </Tab>
      {activeTab === "edit" && (
        <Edit
          data={data}
          npiRecords={npiRecords}
          searchParams={searchParams}
          isViewMode={isViewMode}
          userPermissions={userPermissions}
          currentEntityID={currentEntityID}
          currentEntityItemID={currentEntityItemID}
          updateData={updateData}
          handleSearch={handleSearch}
        />
      )}
      {activeTab === "associations" && (
        <Associations
          entities={entities}
          currentEntityID={currentEntityID}
          currentEntityItemID={currentEntityItemID}
          isViewMode={isViewMode}
          userPermissions={userPermissions}
        />
      )}
      {activeTab === "status" && (
        <StatusDetails
          isViewMode={isViewMode}
          userPermissions={userPermissions}
          currentNPIRecord={currentNPIRecord}
          searchParams={searchParams}
          handleSearch={handleSearch}
        />
      )}
    </div>
  );
};

export default PrimaryTabs;
